<template>
    <div class="row align-items-center" v-loading="loading">
        <div class="col-sm-12 col-md-12">
            <div class="row d-none">
                <div class="col-sm-12">
                    <div class="d-flex align-items-center mb-0">
                        <span class="label label-success label-inline mr-2" style="font-size: 1rem;">Deportista</span>
                        <h3 class="text-dark font-weight-bold mb-0">{{currentAcreditation.athlete}}</h3>
                    </div>
                </div>
            </div>
            <el-form ref="form" :model="documents">
                <div class="row">
                    <div class="col-sm-6 border-right p-4">
                        <h3 class="text-success font-weight-bold mb-5"><i class="el-icon-upload text-success h1"></i> .:Subir:.</h3>
                        <el-form-item label="¿Qué archivo desea subir?" label-width="200px">
                            <el-select v-model="documents.tipo" placeholder="Seleccionar" size="medium" class="w-100">
                                <el-option v-for="item in listFiles" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-upload
                            class="upload-demo w-100 text-center"
                            drag
                            :headers="headers"
                            name="file"
                            :action="url + 'acr/files/upload'"
                            accept=".jpg, .jpeg, .png, .JPG, .JPEG, .PDF"
                            :data="documents"
                            :on-progress="handleProgress"
                            :before-upload="beforeUpload"
                            :on-success="handleSuccess"
                            :on-error="handleError"
                            :file-list="fileList">
                                <i class="el-icon-upload"></i>
                                <div class="el-upload__text">Suelta tu archivo aquí o <em>haz clic para cargar</em></div>
                                <template #tip>
                                    <div class="el-upload__tip">archivos permitidos JPG, JPEG, PNG, PDF <br> con un tamaño menor de 1MB</div>
                                </template>
                        </el-upload>
                    </div>
                    <div class="col-sm-6 p-4">
                        <h3 class="text-success font-weight-bold mb-5"><i class="el-icon-receiving text-success h1"></i> .:En la nube:.</h3>
                        <ul class="list-group" v-if="filesUploads.length>0">
                            <li class="list-group-item" v-for="(item, index) in filesUploads" :key="index">
                                {{item.alias}}
                                <a target="_blank" :href="url + 'writable/uploads/'+item.ruta" class="card-link">(ver archivo)</a>
                            </li>
                        </ul>
                        <el-empty v-else :image-size="200"></el-empty>
                    </div>
                </div>
                <el-divider class="my-4"></el-divider>
                <div class="d-flex justify-content-end">
                    <div class="btn btn-sm btn btn-light" @click="closeModal"><i class="el-icon-close"></i> Cerrar</div>
                </div>
            </el-form>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import JwtService from "@/core/services/jwt.service";
import { MODAL_EDIT , MODAL_NEW } from "@/store/step.module";
import acrService from "@/core/services/acr.service";
import code from "@/core/config/status.code";

export default {
    props: {
        academicdata: {
            type: Object,
            default: () => {}
        },
    },
    data: () => ({
        loading: false,
        url: process.env.VUE_APP_URL_BACKEND,
        documents:{
            tipo: null,
            acrd: null,
            idacreditation: null
        },
        listFiles: [],
        fileList: [],
        formFilter: {},
        filesUploads:[],
        headers:{Authorization: `Bearer ${JwtService.getToken()}`}
    
    }),
    computed: {
        ...mapGetters(['modalNew', 'currentAcreditation', 'modalEdit']),
    },
    beforeMount(){
        if(this.modalEdit){
            this.formFilter = this.academicdata;
            this.documents.idacreditation = this.academicdata.idacreditation;
        }else{
            this.formFilter = this.currentAcreditation;
            this.documents.idacreditation = this.currentAcreditation.idacreditation;
        }
        this.getTypesFiles(); 
        this.getFilesUploads();
    },
    methods: {
        closeModal(){
            if(this.modalEdit){
                this.$store.dispatch(MODAL_EDIT, false);
            }else{
                this.$store.dispatch(MODAL_NEW, false);
            }
        },
        async getTypesFiles(){
            try {
                this.loading = true;
                const res = await acrService.typesFiles(this.formFilter);
                this.listFiles = res.data;
                this.loading = false;
            } catch (e) {
                this.loading = false;
                if (e instanceof acrError) {
                    this.$alert( e.message.data !='' ? e.message.data.messages.error : e.message.statusText, 'Error ' +  e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }
            }
        },
        async getFilesUploads(){
            try {
                this.loading = true;
                const res = await acrService.filesUploads(this.documents.idacreditation);
                this.filesUploads = res.data;
                this.loading = false;
            } catch (e) {
                this.loading = false;
                if (e instanceof acrError) {
                    this.$alert( e.message.data !='' ? e.message.data.messages.error : e.message.statusText, 'Error ' +  e.errorCode, {
                        type: 'warning',
                        confirmButtonText: 'Entendido',
                        callback: action => {
                            code.Manager(e.errorCode);
                        }
                    });
                }
            }
        },
        beforeUpload(file){
            const isLt1M = file.size / 1024 / 1024 < 1;
            if(this.documents.tipo == null){
                this.$notify.error({title: 'Campos vacios', message: 'Falta seleccionar el tipo de archivo a subir'});
                return false;
            }
            if (!isLt1M) {
                this.$message.error('El tamaño del archivo de carga no puede exceder 1 MB!');
                return false;
            }
        },
        handleProgress(event, file, fileList){
        },
        handleSuccess(response, file, fileList){
            this.documents.tipo = null;
            this.$message({message: response.message,type: 'success'});
            this.getFilesUploads();
        },
        handleError(err, file, fileList){
            const e = JSON.parse(err.message);
             this.$alert(  e.messages.error, 'Error ' +  e.error, {type: 'warning'});
        }
    },
    
    
}
</script>